<template>
  <editable-div
    v-model="currentValue"
    ref="nameInput"
    v-on="forwardedListeners"
    @input="contentEdited"
    @keydown.enter.stop="onEnter"
  />
</template>

<style scoped>
.editable-div::v-deep .editable-div-inner {
  /* border-bottom: solid 2px transparent; */
  /* border-top: solid 2px transparent; */
  /* border-top-left-radius: var(--rounding-smaller); */
}
.editable-div::v-deep .editable-div-inner:focus {
  /* border-bottom: solid 2px green; */
}
</style>
<script>
import _ from "lodash";
import editableDiv from "./EditableDiv.vue";

// Delay to save item to database, measured from the last input event
// (i.e. this is completely independent of typingStopDelay).
const kSaveDelayMs = 30 * 1000;

export default {
  props: ["item"],
  data() {
    return {
      currentValue: "",
      // DebouncedSave has to be stored in data in order to have properly
      // bound .cancel() method.
      debouncedSave: _.debounce(() => {
        this.save();
      }, kSaveDelayMs),
    };
  },
  components: { editableDiv },
  computed: {
    // Necessary for setting up a focused watch.
    itemName() {
      return this.item.name;
    },
    // WTF? I think this works in some other way
    forwardedListeners() {
      // 'confirmed' is our custom event. We could probably forward it anyway
      // with no harm, but let's not do that.
      const result = Object.assign({}, this.$listeners);
      delete result.confirmed;
      return result;
    },
  },
  methods: {
    focus() {
      this.$refs.nameInput.focus();
    },
    blur() {
      this.debouncedSave.flush();
      this.$refs.nameInput.blur();
    },
    contentEdited() {
      this.debouncedSave();
    },
    save() {
      if (!this.item || !this.currentValue || !this.item._id) {
        return;
      }
      // contenteditable may return content with a trailing newline which
      // is actually not visible to the user while editing. Remove it.
      const name = this.currentValue.trim();
      this.item.clone({ name }).save();
    },
    onEnter(event) {
      if (event.shiftKey) {
        // Keep default behavior of adding a newline.
        return;
      }
      event.preventDefault();
      this.blur();
      this.$emit("confirmed");
    },
  },
  watch: {
    itemName: {
      immediate: true, // Handle also the initial value.
      handler(newValue, oldValue) {
        if (document.activeElement === this.$refs.nameInput) {
          // The user is still editing the field. Disregard the new value.
          // Updating the field while it has focus sometimes causes
          // a race condition with user input, resulting in horribly broken
          // user experience (caret jumping mid-word, lost input, this sort
          // of things).
          return;
        }
        if (newValue === oldValue && newValue === this.currentValue) {
          return;
        }
        this.currentValue = newValue;
        this.debouncedSave.cancel();
      },
    },
  },
  mounted() {
    this.currentValue = this.itemName;
  },
  beforeDestroy() {
    this.debouncedSave.flush();
  },
};
</script>
